import { DatePicker } from "antd";
import moment, { Moment } from "moment";
import { Controller } from "react-hook-form";
import { useEffect } from "react";
import React, { useState } from "react";
import momentGenerateConfig from 'rc-picker/lib/generate/moment';

const MyDatePicker = DatePicker.generatePicker<Moment>(momentGenerateConfig);

const { RangePicker } = MyDatePicker;

type CustomDatePickerProps = {
  title: string;
  placeholder?: string;
  onChange?: any;
  disabled?: boolean;
  data?: any;
  className?: string;
  showTime?: boolean;
  clearIcon?: boolean;
  rules?: any;
  register?: any;
  id: string;
  name: string;
  setValue?: any;
  control: any;
  warning?: string;
  currentValue?: any;
  suffix?: any;
};

const CustomDateRangePicker: React.FC<CustomDatePickerProps> = ({
  title,
  data,
  onChange,
  disabled,
  // showTime,
  // clearIcon,
  rules,
  id,
  name,
  control,
  setValue,
  warning,
  // currentValue,
  suffix,
  className,
  showTime = false,
  clearIcon = true

}) => {
  const [compDate, setCompDate] = useState<any | undefined>();

  const payloadFormat = showTime ? "YYYY-MM-DD HH:mm:ss" : "YYYY-MM-DD";
  const displayFormat = showTime ? "DD-MMM-YYYY HH:mm:ss" : "DD-MMM-YYYY";

  const disabledDate = (current: number | moment.Moment) => {

    if (rules?.startDate || rules?.default === "currentDate") {
      if (Number(rules?.minDate) > 0) {
        return !(
          current < moment().add(Number(rules.minDate.substring(1)), "day") &&
          current > moment().add(Number(rules.minDate.substring(1)) + 1, "day")
        );
      } else if (Number(rules?.minDate) === 0) {
        return !(
          current < moment().add(rules.maxDate, "day") &&
          current > moment().subtract(Number(rules.minDate.substring(1)) + 1, "day")
        );
      }
      else {
        return !(
          current < moment().add(Number(rules.maxDate.substring(1)), "day") &&
          current > moment().subtract(Number(rules.minDate.substring(1)) + 1, "day")
        );
      }

    }
    current = moment(rules?.startDate);
    return !(
      current < moment().add(rules?.maxDate, "day") &&
      current > moment().subtract(rules?.minDate.substring(1), "day")
    );
  };

  useEffect(() => {

    if (data && setValue) {
      setValue(name, data);

      setCompDate(
        [
          moment(data[0]),
          moment(data[1]),
          payloadFormat
        ]);

    }
    if (data === undefined) {
      setCompDate(undefined);
    }
  }, [data]);


  return (
    <Controller
      name={name}
      control={control}
      rules={{
        required: rules?.mandatory ? `${title} is required` : false,
      }}
      render={({ field, fieldState, formState }) => (
        <div style={{ display: suffix ? "flex" : "block" }}>
          <RangePicker
            // inputRender={inputRender}
            format={displayFormat}
            disabledDate={(current) => disabledDate(current)}
            showTime={showTime}
            disabled={disabled}
            style={{ width: "100%" }}
            className={className}
            id={id}
            {...field}
            onChange={(value:any) => {
              // console.log(value);
              // onChange(value);
              // onChange(value.format(payloadFormat));

            const temp = [value[0].format(payloadFormat), value[1].format(payloadFormat)];
            onChange(temp);
            }}
            value={compDate}
          />
          {fieldState.error?.message && (
            <div className="ant-form-item-explain-error">
              {fieldState.error?.message}
            </div>
          )}

          {warning && (
            <div className="ant-form-item-explain-warning">
              {warning}
            </div>
          )}

          {suffix && (
            <span className="ant-input-suffix">
              {suffix}
            </span>
          )}
        </div>
      )}
    />
  );
};

export default CustomDateRangePicker;
